import ShippingPreferencesDrawerTable from "./ShippingPreferencesDrawerTable";
export default ShippingPreferencesDrawerTable;
